export default __webpack_public_path__ + "static/media/more-cakes.b7d1bdcb.png";